<template>
  <div class="charge-content" v-loading="loading">
    <div class="con-body">
      <el-row :gutter="20" class="list-head">
        <el-col :span="1" :offset="23">
          <el-tooltip class="item" effect="dark" content="刷新列表数据" placement="bottom">
            <el-button icon="el-icon-refresh"  @click="getTableData(pageInfo.page)" size="small" circle></el-button>
          </el-tooltip>
        </el-col>
      </el-row>
      <div class="h15"></div>
      <div class="boder-grey"></div>
      <el-table :data="tableData" style="width: 100%" :row-key="getRowKey" @selection-change="handleSelectionChange" stripe>
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" label="充电桩别名"> </el-table-column>
        <el-table-column prop="number" label="设备编号"> </el-table-column>
        <el-table-column prop="station" label="站点ID"> </el-table-column>
        <el-table-column prop="lamp_name" label="所属路灯">
          <template slot-scope="scope">
            <span>{{ scope.row.lamp_name }} (路灯id：{{ scope.row.lamp_id }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="ste" label="使用状态">
          <template slot-scope="scope">
            <i :class="workColorType[scope.row.work]"></i>
            <span>{{ workType[scope.row.work] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ste" label="充电桩状态">
          <template slot-scope="scope">
            <i :class="steColorType[scope.row.ste]"></i>
            <span>{{ steType[scope.row.ste] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import chargeApi from "@/api/charge/list"
export default {
  data() {
    return {
      steType: ["离线", "在线"],
      steColorType: ["valuered", "valuegreen"],
      workType: ["待机", "充电中"],
      workColorType: ["valueblue", "valuegreen"],
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      multipleSelection: []
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      chargeApi.chargingList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    getRowKey (row) {
      return row.id
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less' scoped>
.charge-content {
  width: 100%;
}
</style> 